export type GQL_ID = string | number

export interface PageInfo {
  page: number
  perPage: number
  lastPage: number
  next: number
  total: number
}

export interface CommonPagerInput {
  limit?: number,
  page?: number
}

export interface CommonListControlsInput {
  _page?: number
  _limit?: number | null
}

export enum FilterOps {
  UNWRAP = 'unwrap',
  EQUAL = 'eq',
  NOT_EQUAL = 'not_eq',
  STARTS_WITH = 'starts_with',
  INCLUDES = 'includes',
  ENDS_WITH = 'ends_with',
  CONTAINS = 'contains',
  NOT_CONTAINS = 'not_contains',
  GREATER = 'gt',
  GREATER_OR_EQUAL = 'gte',
  LESS = 'lt',
  LESS_OR_EQUAL = 'lte',
  BETWEEN = 'between',
  NOT_NULL = 'not_null',
  IS_NULL = 'is_null',
  RELATED_WHERE = 'relatedWhere'
}

export interface NestedFilterInput {
  and?: NestedFilterInput[]
  or?: NestedFilterInput[]
  op?: FilterOps
  fields?: string[]
  value?: string | number | string[] | number[] | null | null[] | (string | number)[]
}

export interface CommonSortInput {
  fieldName: string
  direction: number
}

export interface QueryVariablesTypes {
  pager?: CommonPagerInput,
  filter?: NestedFilterInput,
  sort?: CommonSortInput | Record<string, never>
}

export interface SingleQueryVariableType {
  id: GQL_ID
}

export type CommonAllObjectsQuery<K extends string, T> = {
  [P in K]: {
    edges: T[],
    pageInfo: PageInfo
  }
}

export type CommonSingleQuery<K extends string, T> = {
  [P in K]: T
}